module.exports = __webpack_public_path__ + "img/covadonga.91360df2.jpg";